import { AlertIconWithOrangeBg, NavCloseIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface EstimateErrorsPopupProps {
  onClose: VoidFn;
  errorFields: { [key: string]: boolean };
  maximumAmount: number;
  minimumAmount: number;
  onContinue: VoidFn;
}

const EstimateErrorsPopup: FC<EstimateErrorsPopupProps> = ({
  onClose,
  errorFields,
  maximumAmount,
  minimumAmount,
  onContinue
}) => {
  return (
    <CustomModal open={true} width="md:w-[335px]">
      <div className="relative">
        <div className="absolute right-2.5 top-2.5 cursor-pointer" onClick={onClose}>
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 px-8 py-4">
          <AlertIconWithOrangeBg />

          <div className="text-center text-17px font-semibold text-primaryText">
            Please complete the required fields on your estimate
          </div>
          <ul className="list-disc space-y-4 pl-5 text-left text-sbase text-primaryText">
            {errorFields.customer && <li>Add a customer</li>}
            {errorFields.inCompleteCustomer && <li>Update customer</li>}
            {errorFields.serviceAddress && <li>Service address is required.</li>}
            {errorFields.serviceAddressMissingFields && <li>Some fields are missing in service address.</li>}
            {errorFields.lineItem && <li>At least one line item is required.</li>}
            {errorFields.assignees && <li>At least one assignee is required.</li>}
            {errorFields.title && <li>Title is required.</li>}
            {errorFields.leadSource && <li>Lead source cannot be empty.</li>}
            {errorFields.totalAmount && (
              <li>
                Adjust estimate total to be between {getAmountWithCurrency(minimumAmount)} and{' '}
                {getAmountWithCurrency(maximumAmount)}
              </li>
            )}
            {errorFields.tnc && <li>Terms and conditions cannot be empty.</li>}
          </ul>
        </div>
        <div className="m-4">
          <CustomButton id="estimate-error-confirm" onClick={onContinue} className="h-10 w-full">
            Got it
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default EstimateErrorsPopup;
